'use client';
import { twMerge } from '@shared/themes';
import { useEffect, useRef, type ComponentProps } from 'react';
import { createHorizontalScrollHandlers } from './utils';

function HorizontalScrollContainer({ className, ...props }: Omit<ComponentProps<'div'>, 'ref'>) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const controller = new AbortController();
    const { signal } = controller;
    const { handleMouseDown, handleMouseLeave, handleMouseUp, handleMouseMove, handleClick } = createHorizontalScrollHandlers(el);

    el.addEventListener('mousedown', handleMouseDown, { signal });
    el.addEventListener('mouseleave', handleMouseLeave, { signal });
    el.addEventListener('mouseup', handleMouseUp, { signal });
    el.addEventListener('mousemove', handleMouseMove, { signal });
    el.addEventListener('click', handleClick, { signal, capture: true });

    return () => {
      controller.abort();
    };
  }, []);

  return <div ref={containerRef} className={twMerge('flex min-w-0 gap-x-2 overflow-x-auto hide-scrollbar select-none', className)} {...props} />;
}

export { HorizontalScrollContainer };
